/* eslint-disable */
export function ResponseValidator(data: any) {
  if (!data.status) {
    throw new Error('Response data does not contain a status key');
  }

  return data;
}

